export const rotaAlterarPf = {
    path: 'parceiropf/atualizar',
    name: 'NAN_Parceiro_Pf_Atualizar',
    component: () => import('./AlterarPf.vue'),
    meta: {
        rules: ['NAN-PARCEIROSPF-01'],
    },
    children: [
    ],
};